import styled, { css, keyframes } from 'styled-components'

import { type AnimationProps, AnimationStatus } from '@subaio/components'
import { cases } from '@subaio/utils'

import { helpers } from 'styles'

/** Basic transform property to place modal properly. Useful for animating transform */
export const modalBaseTransform = 'translateX(-50%)'

const easeInQuad = 'cubic-bezier(0.11, 0, 0.5, 0)'
const easeOutQuad = 'cubic-bezier(0.5, 1, 0.89, 1))'

const animationDesktopIn = keyframes`
	0% {
		opacity: 0;
		transform: ${modalBaseTransform} translateY(-180px) scale(0.1);
	}
`

const animationDesktopOut = keyframes`
	100% {
		opacity: 0;
	}
`

const animationMobile = keyframes`
	0% {
		opacity: 0;
		transform: translateY(300px);
	}
`

/** Modal base component. Placed in the center of screen, but nothing beyond that. */
export const Wrapper = styled.div<AnimationProps>`
	position: absolute;
	left: calc(50%);
	top: 16px;
	width: 400px;
	min-width: 50%;
	max-height: 90%;
	overflow-y: auto;
	pointer-events: auto;
	background-color: ${helpers.color.cardBackground};

	@media (min-width: 769px) {
		transform: ${modalBaseTransform};
		box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.12), 0px 7px 14px 0px rgba(60, 66, 87, 0.08);
		border-radius: 4px;

		${({ status, duration }) =>
			cases(status, {
				[AnimationStatus.Entering]: css`
				animation: ${duration}s ${animationDesktopIn} ${easeInQuad};
			`,
				[AnimationStatus.Exiting]: css`
				animation: ${duration}s ${animationDesktopOut} ${easeOutQuad} forwards;
			`,
			})}
	}

	@media (max-width: 768px) {
		top: unset;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: 0;
		width: 100%;
		max-height: 80%;
		height: 500px;

		${({ status, duration }) =>
			cases(status, {
				[AnimationStatus.Entering]: css`
				animation: ${duration}s ${animationMobile} ${easeInQuad};
			`,
				[AnimationStatus.Exiting]: css`
				animation: ${duration}s ${animationMobile} ${easeOutQuad} reverse forwards;
			`,
			})}
	}
`
